export const FETCH_WISHLIST_DATA = "WISHLIST/FETCH_WISHLIST_DATA";
export const FETCH_WISHLIST_CATEGORY_LIST = "WISHLIST/FETCH_WISHLIST_CATEGORY_LIST";
export const FETCH_CUSTOMER_WISHLIST_ITEMS = "WISHLIST/FETCH_CUSTOMER_WISHLIST_ITEMS";
export const GENERATE_WISHLIST_ITEM_REPORT = "WISHLIST/GENERATE_WISHLIST_ITEM_REPORT";
export const GENERATE_WISHLIST_STORE_REPORT = "WISHLIST/GENERATE_WISHLIST_STORE_REPORT";
export const SAVE_WISHLIST_DATA = "WISHLIST/SAVE_WISHLIST_DATA";
export const SET_WISHLIST_FLAG = "WISHLIST/SET_WISHLIST_FLAG";
export const SEND_WISHLIST_REMINDER = "WISHLIST/SEND_WISHLIST_REMINDER";
